import React from 'react';
import { List, ListItemButton } from '@mui/material';
import { ThemeContext } from 'src/store/ContextStore';

import { CONSTANTS, PEDIGREE } from 'src/components/Constants';

const AdoptedMenu = ({
  node,
  memberRecords,
  setMemberRecords,
  handleClose,
  setPedigreeState
}) => {
  const { theme } = React.useContext(ThemeContext);
  const data = node;

  //   const adopted = data?.adopted_in || data?.adopted_out;

  const onChange = (value) => {
    const data = node;

    const idx = memberRecords.findIndex((person) => data.pid === person.pid);

    memberRecords[idx] = {
      ...memberRecords[idx],
      adopted: value
    };

    // handleDetailsChange([memberRecords[idx]]);

    setMemberRecords([...memberRecords]);

    setPedigreeState((prev) => ({
      ...prev,
      save: PEDIGREE.saveStatus.IN_PROGRESS
    }));

    handleClose();
  };

  return (
    <List>
      {CONSTANTS.adoptedMap.map((option, idx) => {
        return (
          <ListItemButton
            key={idx}
            // style={{
            //   backgroundColor: option.value === adopted && theme.buttonStyle
            // }}
            onClick={() => onChange(option.value)}
          >
            {option.label}
          </ListItemButton>
        );
      })}
    </List>
  );
};

export default AdoptedMenu;
